import React, { useContext } from 'react';
import IconEdit from 'shared/icons/iconEdit';
import IconDownload from 'shared/icons/iconDownload';
import IconRestore from 'shared/icons/iconRestore';
import IconTrash from 'shared/icons/trash';
import { UiContext } from 'shared/lib/contexts/uiContext';
import { GridRowContext } from 'shared/lib/extendedComponents/grids/components/gridRowContainer';
import { Box, IconButton, Tooltip, useTheme } from '@mui/material';
import { makeTransition } from 'shared/lib/utils/utils';
import CellContainer from 'shared/lib/extendedComponents/grids/components/cellContainer';
import IconGear from 'shared/icons/gear/iconGear';
import { isTouchDevice } from 'shared/lib/utils/globalUtils';
import FavoriteIconController from 'shared/icons/favourite/favoriteIconController';

export default function DesktopSettingsCell({
  onDownload,
  onEdit,
  onSettings,
  onRestore,
  onDelete,
  onFavorite,
  isFavorite,
}: {
  onDownload?: () => void;
  onEdit?: () => void;
  onSettings?: () => void;
  onRestore?: () => void;
  onDelete?: () => void;
  onFavorite?: () => void;
  isFavorite?: boolean;
}) {
  const theme = useTheme();

  const isHover = useContext(GridRowContext).isHover || isTouchDevice();

  const {
    spacings: { sp },
  } = useContext(UiContext);

  const visibilitySx = isHover
    ? { opacity: 1, pointerEvents: 'all' }
    : { opacity: 0, pointerEvents: 'none' };

  return (
    <CellContainer
      sx={{
        position: 'relative',
        alignItems: 'end',
        cursor: 'pointer',
        overflow: 'visible',
        p: 0,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          pr: sp.s25,
          pl: 10,
          background:
            'linear-gradient(270deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.8) 73.96%, rgba(255, 255, 255, 0) 97.04%)',
          flexGrow: 1,
          right: 0,
          transition: makeTransition(['opacity']),
          ...visibilitySx,
        }}
      >
        {onDownload && (
          <Tooltip title="Скачать" placement="bottom">
            <IconButton
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onDownload();
              }}
            >
              <IconDownload
                sizeKey="20x20"
                extColor={theme.palette.primary.main}
              ></IconDownload>
            </IconButton>
          </Tooltip>
        )}
        {onEdit && (
          <Tooltip title="Редактировать" placement="bottom">
            <IconButton
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onEdit();
              }}
            >
              <IconEdit
                sizeKey="20x20"
                extColor={theme.palette.primary.main}
              ></IconEdit>
            </IconButton>
          </Tooltip>
        )}
        {onSettings && (
          <Tooltip title="Настроить" placement="bottom">
            <IconButton
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onSettings();
              }}
            >
              <IconGear
                sizeKey="20x20"
                extColor={theme.palette.primary.main}
              ></IconGear>
            </IconButton>
          </Tooltip>
        )}
        {onRestore && (
          <Tooltip title="Восстановить" placement="bottom">
            <IconButton
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onRestore();
              }}
            >
              <IconRestore
                sizeKey="20x20"
                extColor={theme.palette.primary.main}
              ></IconRestore>
            </IconButton>
          </Tooltip>
        )}
        {onDelete && (
          <Tooltip title="Удалить" placement="bottom">
            <IconButton
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onDelete();
              }}
            >
              <IconTrash
                sizeKey="20x20"
                extColor={theme.palette.primary.main}
              ></IconTrash>
            </IconButton>
          </Tooltip>
        )}
        {onFavorite && (
          <Tooltip
            title={isFavorite ? 'Убрать из избранного' : 'Добавить в избранное'}
            placement="bottom"
          >
            <IconButton
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onFavorite();
              }}
            >
              <FavoriteIconController
                isFavourite={!!isFavorite}
                sizeKey="20x20"
                extColor={theme.palette.primary.main}
              ></FavoriteIconController>
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </CellContainer>
  );
}
